import moment from 'moment'
import React, {useEffect, useState} from 'react'
import firebase from '../../firebase/config'

function Sales() {

    const [user, setUser] = useState({})
    const [countryInfo, setCountryInfo] = useState({})

    const [products, setProducts] = useState([])
    const [productsTypes, setProductsTypes] = useState([])
    const [productsSelected, setProductsSelected] = useState([])
    const [listCountedItems, setListCountedItems] = useState([])

    const [price, setPrice] = useState(0)

    const [searchName, setSearchName] = useState(null)
    const [searchSku, setSearchSku] = useState(null)
    const [searchCategorie, setSearchCategorie] = useState(null)

    const [success, setSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    
    function filterName(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].titulo
        let uLower = u.toLowerCase()

        if( uLower.includes(val.toLowerCase()) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterSku(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].sku !== undefined ? list[i].sku.toString() : ""

        if( u.includes(val) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterCategorie(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].categoria
        if(u === val){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function checkIfExists(list){
      let listPredefined = [...list]
      for(let i = 0; i < listPredefined.length; i++){
        let productoMain = listPredefined[i]
        
        productsSelected.forEach((productoSelected)=>{        
          if(productoMain === productoSelected){
            listPredefined[i] = productoSelected
          }
        })

      }
      return listPredefined
    }

    const getProducts = async(aliadoId) =>{
      let tipos = [];
      await firebase.db.collection('Productos').where("aliadoId", "==", aliadoId).get().then(val => {
        val.docs.forEach(item=>{

          //Si en la lista de productos seleccionados existe el producto entonces se reemplaza el producto nuevo por el seleccionado

          let a = {
            ...item.data()
          }
          tipos.push(a)
          tipos.sort()
        })

        let allList = tipos
        let filteredName = searchName ? filterName(tipos, searchName) : allList
        let filteredSku = searchSku ? filterSku(filteredName, searchSku) : filteredName
        let filteredCategorie = searchCategorie !== "Todas" && searchCategorie ? filterCategorie(filteredSku, searchCategorie) : filteredSku
        let list = checkIfExists(filteredCategorie)


        setProducts(list.sort((a, b) => b.createdOn - a.createdOn))

      })
    }

    const getProductsTypes = async() =>{
      let tipos = [];
      await firebase.db.collection('tipoProductos').get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.id)
          tipos.sort()
        })
        tipos.pop("Todas")
        setProductsTypes(tipos)
      })
    }

    
    function uniqBy(a, key) {
      var seen = {};
      return a.filter(function(item) {
          var k = key(item);
          return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      })
    }

    function addProduct(prod){
      if( !productsSelected.includes(prod) ){
        let val = {
          id: prod.productoId,
          countedItems: 1
        }
    
        let p = price + prod.precio
        let precioRounded = Math.round(p * 100) / 100
        setPrice(precioRounded)

        let a = uniqBy(productsSelected, JSON.stringify)

        setProductsSelected([...a, prod])
        setListCountedItems([...listCountedItems, val])
      }else{
        console.log("Ya lo contiene")
      }
      

    }

    function removeProduct(prod, obj){

      let p = price - (prod.precio * obj.countedItems)
      let precioRounded = Math.round(p * 100) / 100
      setPrice(precioRounded)

      setProductsSelected(productsSelected.filter((p1) => p1 !== prod))
      setListCountedItems(listCountedItems.filter((p1) => p1 !== obj))
    }

    function sumProduct(o, prod){
      let newArr = [...listCountedItems];

      let iDefaultProInList = newArr.findIndex((prod1) => prod1.id === o.id);

      if( newArr[iDefaultProInList]["countedItems"] >= 1 ){
        
        let p = price + prod.precio
        let precioRounded = Math.round(p * 100) / 100
        setPrice(precioRounded)

        newArr[iDefaultProInList] = { ...o, countedItems: o.countedItems + 1 };
        setListCountedItems(newArr);
      }
    }
    
    function restProduct(o, prod){
      let newArr = [...listCountedItems];

      const iDefaultProInList = newArr.findIndex((prod1) => prod1.id === o.id);

      if( newArr[iDefaultProInList]["countedItems"] > 1 ){
        
        let p = price - prod.precio
        let precioRounded = Math.round(p * 100) / 100
        setPrice(precioRounded)

        newArr[iDefaultProInList] = { ...o, countedItems: o.countedItems - 1 };
        setListCountedItems(newArr);
      }

    }

    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getProducts(val.aliadoId)
          firebase.getCountryInfo(val.pais).then((val)=>{
            setCountryInfo(val.data()) 
          })          
        })
        getProductsTypes()
    }, [])
    
    return (
        <div className="main-content-container container-fluid px-4">
          {success && <SuccessComponent msg={successMsg === "" ? "Producto cargado exitosamente" : successMsg}/>}

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="page-title"><span>Ventas</span></p>
                    </div>
                  </div>
                </div>
            </div>

            <div className="row no-gutters">
              <div className="col-lg-8 pr-5">
           
                <div className="mt-1 mb-4 row no-gutters align-items-center">

                  <div className="form-group mr-3 mb-0 col-lg-3">
                    <input type="text" placeholder="Nombre del producto" className="form-control" onChange={(e)=>{ setSearchName(e.target.value) }}/>
                  </div>
                  <div className="form-group mr-3 mb-0 col-lg-3">
                    <input type="text" placeholder="SKU del producto" className="form-control" onChange={(e)=>{ setSearchSku(e.target.value) }}/>
                  </div>
                  <div className="form-group mr-3 mb-0 col-lg-3">
                    <select className="form-control" onChange={(e) => { setSearchCategorie(e.target.value) }}>
                      <option value="">Categoría</option>
                      {productsTypes.map(data => (
                        <option key={data} value={data}>{data}</option>
                        ))}
                      <option value="Todas">Todas</option>
                    </select>
                  </div>
                      
                  <button className="btn btn-primary col-lg-1" onClick={()=>{getProducts( user.aliadoId )}}><i className="material-icons">search</i></button>
                      
                </div>

                <div className="row-content-container-title">
                  <div className="row-content-container-img"></div>
                  <div className="row-content-container-body">
                    <p className="row-content-container-title-title">Nombre</p>
                    <p className="row-content-container-title-cat">Categoría</p>
                    <p className="row-content-container-title-price">Precio</p>
                    <p className="row-content-container-title-stock">Cantidad</p>
                  </div>
                </div>

                { products.length > 0 ? products.map((prod) => {
                  let precioRounded = Math.round(prod.precio * 100) / 100
                  let obj = listCountedItems.find(o => o.id === prod.productoId);

                  return(
                    <div onClick={()=>{ 
                      productsSelected.includes(prod) ? removeProduct(prod, obj) : addProduct(prod)
                    }} className="row-content-container" key={prod.productoId}>
                      <img src={prod.urlImagen} alt="" className="row-content-container-img" />
                      <div className="row-content-container-body">
                        <p className="row-content-container-p-title">{prod.titulo}</p>
                        <p className="row-content-container-p-cat">{prod.categoria}</p>
                        <p className="row-content-container-p-price">{countryInfo.simbolo ?? " "}{precioRounded}</p>
                        <p className="row-content-container-p-stock">{prod.cantidad}</p>
                        { productsSelected.includes(prod) && <p className="row-content-container-p-tag material-icons">done</p> }
                      </div>
                    </div>
                  )
                }) : <div className="text-center"><p>No hay productos</p></div> }

              </div>

              <div className="col-lg-4 row-content-container-right">
                <p className="row-content-container-right-title">Productos seleccionados</p>
                <p className="row-content-container-right-desc">Selecciona algunos productos para generar el pedido</p>
                <div className="row-content-container-right-wrapper">
                
                  { productsSelected.length > 0 ? productsSelected.map((prod, i) => {
                      let precioRounded = Math.round(prod.precio * 100) / 100
                      let obj = listCountedItems.find(o => o.id === prod.productoId);

                      return(
                        <div className="row-content-container-right-content fadeInTop" key={prod.productoId}>
                          <img src={prod.urlImagen} alt="" className="row-content-container-right-img" />
                          <div className="row-content-container-right-body">
                            <p className="row-content-container-right-p-title">{prod.titulo}</p>
                            <p className="row-content-container-right-p-price">{countryInfo.simbolo ?? " "}{precioRounded}</p>
                            <div style={{width: "90px"}} className="fadeInTop row no-gutters align-items-center justify-content-spacebetween">
                              <div onClick={()=>{ restProduct(obj, prod) }} className="product-card-selection-btn">{"-"}</div>
                              <p className="product-card-selection-number mb-0">{obj.countedItems}</p>
                              <div onClick={()=>{ sumProduct(obj, prod) }} className="product-card-selection-btn">{"+"}</div>
                            </div>
                          </div>
                        </div>
                      )
                    }) : <div className="text-center mt-4 color-primary light"><p>Aqui se mostraran los productos que selecciones</p></div> }

                </div>
                  { productsSelected.length > 0 && <div className="fadeIn row-content-container-right-footer">
                    <div className="row no-gutters justify-content-spacebetween">
                      <p style={{ fontSize: "15px" }} className="mb-2 color-primary">Costo total:</p>  <p style={{ fontSize: "20px" }} className="mb-2 color-primary bold">{countryInfo.simbolo ?? " "}{price}</p>
                    </div>
                    <div onClick={()=>{ createOrden() }} className="btn btn-outline-primary btn-block">Generar pedido</div>
                  </div> }
              </div>
            
            </div>


        </div>
    )

    async function createOrden(){

      const oid = moment().valueOf().toString()

      let items = []

      Promise.all(productsSelected.map(async (pro, i) => {
        let iI = moment().valueOf().toString()

        let item = {
          aliadoId: user.aliadoId,
          cantidad: listCountedItems[i].countedItems,
          iId: iI + i,
          nombreComercial: user.nombreComercial,
          precio: pro.precio,
          productoId: pro.productoId,
          titulo: pro.titulo,
          uid: "",
          walkin: true,
        }

        items.push(item)
      }))


      let order = {
        aliadoId: user.aliadoId,
        createdOn: moment().toDate(),
        delivery: 0,
        nombreComercial: user.nombreComercial,
        oid: oid,
        pais: user.pais,
        ppGeneradosD: "",
        precio: price,
        status: "Por cobrar",
        tieneDelivery: false,
        tipoOrden: "Producto",
        uid: "",
        walkin: true,
        user:  "Cliente",
        statusPago: "Por cobrar"
      }

      await firebase.db.collection("Ordenes").doc(oid).set({
        ...order
      })
      
      
      Promise.all(items.map(async (it) => {
        await firebase.db.collection("Ordenes").doc(oid).collection("Items").doc(it.iId).set({
          ...it
        })
      }))

      setSuccessMsg("Pedido generado exitosamente")
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 4000);

      // console.log("Orden: ", order)
      // console.log("Items: ", items)

    }

}

export default Sales